import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { useEnigmaToken } from "@hooks/useEnigmaToken";
import { Size, SizeHeightMappings } from "@type/sizing";
import { StyledInputProps } from "./input.types";

const getSizeBasedStyle = ({
    size = Size.medium,
    hasPrefix,
    hasSuffix,
}: StyledInputProps) => {
    // This next step is required because antd adds extra padding-left on input container when prefix/suffix is present.
    // Which creates unwanted space between prefix/suffix and input.
    // Setting it to zero and only have antd's padding for better view.
    const paddingRight = hasSuffix ? "8px" : "12px";
    const paddingLeft = hasPrefix ? "8px" : "12px";
    return css`
        padding: 0 ${paddingRight} 0 ${paddingLeft};
        height: ${SizeHeightMappings[size]};
    `;
};

const getCSSFromToken = () => {
    const token = useEnigmaToken();
    return css`
        font-size: ${token.fontSize}px;
        border-radius: ${token.borderRadiusSM}px;
        line-height: 155%;
    `;
};

const getAddOnCSS = () => {
    const token = useEnigmaToken();
    return css`
        border-radius: ${token.borderRadiusSM}px;
        background: transparent;
    `;
};

const getAffixIconCss = ({ size = Size.medium }: StyledInputProps) => {
    const token = useEnigmaToken();
    return css`
        height: ${SizeHeightMappings[size]};
        border-radius: ${token.borderRadiusSM}px;
    `;
};

// Removing all the block padding in input container of antd.
// As we are adding our own custom padding, antd's padding creates additional unwanted space and handling.
export const StyledInputContainer = styled.span<StyledInputProps>`
    & * {
        padding-block: 0;
    }

    && input {
        ${(props) => getSizeBasedStyle(props)}
        ${() => getCSSFromToken()}
    }

    .enigma-input-prefix {
        padding-left: 12px;
        margin-right: 0;
    }

    .enigma-input-suffix {
        padding-right: 12px;
        margin-left: 0;
    }

    .ant-input-affix-wrapper {
        ${(props) => getAffixIconCss(props)}
        padding: 0;
        display: flex;
        align-items: center;
    }

    .ant-input-group-addon {
        ${() => getAddOnCSS()}
    }

    display: inline-block;
    width: 100%;
`;
